import React from 'react';
import { Alert, Badge, Button, Card, Col, Form, InputGroup, Row, Spinner, Table } from 'react-bootstrap';
import { Auth, API } from "aws-amplify";
import moment from 'moment';
import { Locations } from "../../components/contstants/Locations";

export default class ModifyStudentData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searching: false,
            saving: false,
            saveSuccess: "",
            data: [],
            filteredStudents: [],
            selectedStudent: {},
            editedStudent: {},
            availableOptions: [],
            fName: "",
            lName: "",
            date: "",
            yearOptions: [],
            filterYear: "",
            locations: Locations,
        };
    }

    componentDidMount() {
        let currentYear = moment().add(1, "year").year();
        const yearOptions = ["All Years"];
        while (currentYear > 2022) {
            yearOptions.push(String(currentYear));
            currentYear--;
        }
        this.setState({ yearOptions, filterYear: moment().format("YYYY") });

        fetch('https://s3.amazonaws.com/publicdates/roadTestPackages.json', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'GET'
        })
            .then(response => {
                if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
                return response.json();
            })
            .then(data => this.setState({ availableOptions: data }))
            .catch(error => console.error("Failed to load packages:", error));
    }

    handleChange = e => {
        this.setState({ [e.target.id]: e.target.value, filteredStudents: [], selectedStudent: {}, editedStudent: {} });
    }

    onRadioPackageChange = e => {
        this.setState(prev => ({
            editedStudent: { ...prev.editedStudent, selectedPackage: e.currentTarget.id }
        }));
    }

    onLocationChange = location => {
        this.setState(prev => ({
            editedStudent: { ...prev.editedStudent, location }
        }));
    }

    onCertificateChange = status => {
        this.setState(prev => ({
            editedStudent: { ...prev.editedStudent, certPaymentStatus: !status }
        }));
    }

    handleEditChange = e => {
        const { name, value } = e.target;
        this.setState(prev => ({
            editedStudent: { ...prev.editedStudent, [name]: value }
        }));
    }

    handleParkwayUpdate = () => {
        this.setState(prev => ({
            editedStudent: { ...prev.editedStudent, drivingSchool: "Parkway Driving School" }
        }));
    }

    handleStudentEdit = index => {
        const selectedStudent = this.state.filteredStudents[index];
        this.setState({
            selectedStudent,
            editedStudent: JSON.parse(JSON.stringify(selectedStudent)),
            moveError: ""
        });
    }

    handleCancelEdit = () => {
        this.setState({ selectedStudent: {}, editedStudent: {}, moveError: "" });
    }

    findStudents = () => {
        this.getFilteredStudents();
    }

    resetFilters = () => {
        this.setState({
            fName: "",
            lName: "",
            date: "",
            filterYear: "All Years",
            selectedStudent: {}
        });
    }

    getFilteredStudents = async () => {
        const filters = {};
        if (moment(this.state.date, 'YYYY-MM-DD', true).isValid()) {
            filters.date = moment(this.state.date).format('YYYY-MM-DD');
        }
        if (this.state.fName && this.state.fName.length > 0) {
            filters.fName = this.state.fName;
        }
        if (this.state.lName && this.state.lName.length > 0) {
            filters.lName = this.state.lName;
        }
        if (this.state.filterYear && this.state.filterYear !== "All Years") {
            filters.filterYear = this.state.filterYear;
        }

        if (Object.keys(filters).length === 0) {
            this.setState({ dateError: "You must specify at least one filter." });
            return;
        }

        this.setState({ searching: true, dateError: "", refreshStatus: "" });
        try {
            const session = await Auth.currentSession();
            const options = {
                body: filters,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': session.idToken.jwtToken
                }
            };
            const data = await API.post("APIGateway", "/v2getStudentsByFilter", options);
            this.setState({
                data,
                searching: false,
                filteredStudents: data,
                refreshStatus: `${data.length} result${data.length === 1 ? "" : "s"} found.`,
                dateError: ""
            });
        } catch (error) {
            this.setState({
                searching: false,
                dateError: "There was an error loading students. Please try again or contact your developer. " + JSON.stringify(error)
            });
        }
    }

    handleUpdateUser = async event => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({ saving: true, moveError: "" });

        const oldStudent = this.state.selectedStudent;
        const student = { ...this.state.editedStudent };

        if (!moment(student.date, 'YYYY-MM-DD', true).isValid()) {
            this.setState({ moveError: "Invalid Date Entry.", saving: false });
            return;
        }

        let mode = "updateStudent2";
        if (oldStudent.date !== student.date) {
            mode = "updateAndDeleteOld";
            if (student.emailInitalState !== "Not Sent") {
                student.emailInitalState = "Not Sent";
            }
            if (student.emailRoadTestPassedState !== "Not Sent") {
                student.emailRoadTestPassedState = "Not Sent";
            }
            if (student.emailRoadTestSlotConfirmed !== "Email Not Sent") {
                student.emailRoadTestSlotConfirmed = "Email Not Sent";
            }
            if (student.emailRoadTestSlotState !== "Not Sent") {
                student.emailRoadTestSlotState = "Not Sent";
            }
            delete student.validateToken;
            delete student.slot;
            delete student.unslotTime;
            delete student.weekendDate;
        }

        try {
            const session = await Auth.currentSession();
            const options = {
                body: [{ mode, student, newDate: student.date, oldDate: oldStudent.date }],
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': session.idToken.jwtToken
                }
            };
            const data = await API.post("APIGateway", "/modifystudentdata", options);
            if (data.hasOwnProperty('type') && data.type === "success") {
                const updatedList = [...this.state.filteredStudents];
                const idx = updatedList.indexOf(this.state.selectedStudent);
                if (idx !== -1) {
                    if (mode === "updateAndDeleteOld") {
                        updatedList.splice(idx, 1);
                    } else {
                        updatedList[idx] = { ...student };
                    }
                }
                this.setState({
                    editedStudent: {}, selectedStudent: {}, saving: false,
                    filteredStudents: updatedList, data: updatedList,
                    refreshStatus: `${updatedList.length} result${updatedList.length === 1 ? "" : "s"} found.`,
                    saveSuccess: `${student.fName} ${student.lName} was successfully updated.`
                });
            } else {
                this.setState({ saving: false, moveError: "Update failed. Please try again." });
            }
        } catch (error) {
            this.setState({
                saving: false,
                moveError: "There was an error updating the student. Please try again or contact your developer."
            });
        }
    }

    render() {
        const { filteredStudents, selectedStudent, editedStudent, searching, saving, saveSuccess, dateError, refreshStatus, moveError, locations } = this.state;

        return (
            <div className="holder">
                {/* Alerts */}
                {dateError && (
                    <Alert variant="warning" onClose={() => this.setState({ dateError: "" })} dismissible>
                        <strong>{dateError}</strong>
                    </Alert>
                )}
                {refreshStatus && (
                    <Alert variant="info" onClose={() => this.setState({ refreshStatus: "" })} dismissible style={{ padding: "0.4rem 0.75rem" }}>
                        {refreshStatus}
                    </Alert>
                )}
                {saveSuccess && (
                    <Alert variant="success" onClose={() => this.setState({ saveSuccess: "" })} dismissible style={{ padding: "0.4rem 0.75rem" }}>
                        {saveSuccess}
                    </Alert>
                )}

                {/* Page header */}
                <div style={{ marginBottom: "1.25rem" }}>
                    <h3 style={{ marginBottom: "0.25rem" }}>Find and Modify Student Record</h3>
                    <small className="text-muted">Search for a student by year, date, or name, then click Edit to modify their record.</small>
                </div>

                {/* Search filters */}
                <Card style={{ marginBottom: "1.5rem" }}>
                    <Card.Header><strong>Search Filters</strong></Card.Header>
                    <Card.Body>
                        <Form>
                            <Row>
                                <Col md={3}>
                                    <Form.Group controlId="filterYear" style={{ marginBottom: "0.75rem" }}>
                                        <Form.Label>Year</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="filterYear"
                                            onChange={this.handleChange}
                                            value={this.state.filterYear}
                                        >
                                            {this.state.yearOptions.map(year => (
                                                <option key={year} value={year}>{year}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group controlId="date" style={{ marginBottom: "0.75rem" }}>
                                        <Form.Label>Date</Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={this.state.date}
                                            onChange={this.handleChange}
                                            id="date"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group controlId="fName" style={{ marginBottom: "0.75rem" }}>
                                        <Form.Label>First Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="First name"
                                            value={this.state.fName}
                                            onChange={this.handleChange}
                                            id="fName"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group controlId="lName" style={{ marginBottom: "0.75rem" }}>
                                        <Form.Label>Last Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Last name"
                                            value={this.state.lName}
                                            onChange={this.handleChange}
                                            id="lName"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                        <div style={{ display: "flex", gap: "0.5rem" }}>
                            <Button variant="primary" size="sm" disabled={searching} onClick={this.findStudents}>
                                {searching ? <><Spinner animation="border" size="sm" /> Searching…</> : "Find Students"}
                            </Button>
                            <Button variant="outline-secondary" size="sm" disabled={searching} onClick={this.resetFilters}>
                                Reset
                            </Button>
                        </div>
                    </Card.Body>
                </Card>

                {/* Results */}
                {filteredStudents.length > 0 && (
                    <Card>
                        <Card.Header style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                            <strong>Results</strong>
                            <Badge variant="secondary">{filteredStudents.length}</Badge>
                        </Card.Header>
                        <Card.Body style={{ padding: 0 }}>
                            <Table striped bordered hover responsive size="sm" style={{ margin: 0 }}>
                                <thead className="thead-dark">
                                    <tr className="d-flex">
                                        <th className="col-2">Date</th>
                                        <th className="col-1">First Name</th>
                                        <th className="col-1">Last Name</th>
                                        <th className="col-2">DOB</th>
                                        <th className="col-2">Parent Email</th>
                                        <th className="col-3">Lessons</th>
                                        <th className="col-1">Edit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredStudents.map((x, index) => (
                                        <React.Fragment key={x.permitNo || index}>
                                            <tr className="d-flex" style={selectedStudent === x ? { backgroundColor: "#e8f4fd" } : undefined}>
                                                <td className="col-2">{x.date}</td>
                                                <td className="col-1">{x.fName}</td>
                                                <td className="col-1">{x.lName}</td>
                                                <td className="col-2">{x.dob}</td>
                                                <td className="col-2">{x.parentEmailAddress}</td>
                                                <td className="col-3">
                                                    {(x.selectedPackage || '').includes("Lesson") ? (
                                                        x.scheduledLessons && x.scheduledLessons.length > 0 ? (
                                                            x.scheduledLessons.map((lesson, i) => (
                                                                <div key={i}>
                                                                    {moment(lesson.date).format("MM/DD/YYYY") + " at " + lesson.slotName + " in " + lesson.location + " with " + lesson.instructor}
                                                                </div>
                                                            ))
                                                        ) : "No Lessons Scheduled"
                                                    ) : "N/A"}
                                                </td>
                                                <td className="col-1">
                                                    <Button
                                                        variant={selectedStudent === x ? "primary" : "outline-primary"}
                                                        size="sm"
                                                        onClick={() => selectedStudent === x ? this.handleCancelEdit() : this.handleStudentEdit(index)}
                                                    >
                                                        {selectedStudent === x ? "Close" : "Edit"}
                                                    </Button>
                                                </td>
                                            </tr>

                                            {selectedStudent === x && (
                                                <tr>
                                                    <td colSpan={6} style={{ padding: "1rem", backgroundColor: "#f8f9fa" }}>
                                                        {moveError && (
                                                            <Alert variant="danger" style={{ marginBottom: "1rem" }}>
                                                                <strong>{moveError}</strong>
                                                            </Alert>
                                                        )}
                                                        <Form noValidate onSubmit={this.handleUpdateUser}>
                                                            <Row>
                                                                <Col md={6}>
                                                                    <Form.Group controlId="editDate">
                                                                        <Form.Label><strong>Road Test Date</strong></Form.Label>
                                                                        <Form.Control
                                                                            required
                                                                            name="date"
                                                                            type="date"
                                                                            value={editedStudent.date}
                                                                            onChange={this.handleEditChange}
                                                                        />
                                                                        <Form.Control.Feedback type="invalid">Please input a road test date.</Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row>

                                                            <Form.Group style={{ marginBottom: "1rem" }}>
                                                                <Form.Label><strong>Road Test Location</strong></Form.Label>
                                                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.25rem 1rem" }}>
                                                                    {locations.map(location => (
                                                                        <Form.Check
                                                                            key={location}
                                                                            checked={location === editedStudent.location}
                                                                            name="location"
                                                                            type="radio"
                                                                            id={"edit-" + location}
                                                                            onChange={() => this.onLocationChange(location)}
                                                                            label={location}
                                                                        />
                                                                    ))}
                                                                </div>
                                                            </Form.Group>

                                                            <Form.Group style={{ marginBottom: "1rem" }}>
                                                                <Form.Label><strong>Driving School</strong></Form.Label>
                                                                <InputGroup>
                                                                    <Form.Control
                                                                        name="drivingSchool"
                                                                        type="text"
                                                                        value={editedStudent.drivingSchool}
                                                                        placeholder="Enter Driving School Name (Optional)"
                                                                        onChange={this.handleEditChange}
                                                                    />
                                                                    <InputGroup.Append>
                                                                        <Button variant="outline-secondary" onClick={this.handleParkwayUpdate}>Parkway</Button>
                                                                    </InputGroup.Append>
                                                                </InputGroup>
                                                            </Form.Group>

                                                            <Row>
                                                                <Col md={6}>
                                                                    <Form.Group>
                                                                        <Form.Label><strong>First Name</strong></Form.Label>
                                                                        <Form.Control
                                                                            required
                                                                            name="fName"
                                                                            type="text"
                                                                            value={editedStudent.fName}
                                                                            placeholder="First Name"
                                                                            onChange={this.handleEditChange}
                                                                        />
                                                                        <Form.Control.Feedback type="invalid">Please input a name.</Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <Form.Group>
                                                                        <Form.Label><strong>Last Name</strong></Form.Label>
                                                                        <Form.Control
                                                                            required
                                                                            name="lName"
                                                                            type="text"
                                                                            value={editedStudent.lName}
                                                                            placeholder="Last Name"
                                                                            onChange={this.handleEditChange}
                                                                        />
                                                                        <Form.Control.Feedback type="invalid">Please input a name.</Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row>

                                                            <Row>
                                                                <Col md={6}>
                                                                    <Form.Group>
                                                                        <Form.Label><strong>Permit Number</strong></Form.Label>
                                                                        <Form.Control
                                                                            required
                                                                            name="permitNo"
                                                                            type="text"
                                                                            value={editedStudent.permitNo}
                                                                            placeholder="Enter permit number"
                                                                            onChange={this.handleEditChange}
                                                                        />
                                                                        <Form.Control.Feedback type="invalid">Please input a permit number.</Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row>

                                                            <Row>
                                                                <Col md={6}>
                                                                    <Form.Group controlId="editDob">
                                                                        <Form.Label><strong>Date of Birth</strong></Form.Label>
                                                                        <Form.Control
                                                                            required
                                                                            name="dob"
                                                                            type="date"
                                                                            value={editedStudent.dob}
                                                                            onChange={this.handleEditChange}
                                                                        />
                                                                        <Form.Control.Feedback type="invalid">Please input a DOB.</Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <Form.Group>
                                                                        <Form.Label><strong>Permit Issue Date</strong></Form.Label>
                                                                        <Form.Control
                                                                            required
                                                                            name="permitDate"
                                                                            type="date"
                                                                            value={editedStudent.permitDate}
                                                                            onChange={this.handleEditChange}
                                                                        />
                                                                        <Form.Control.Feedback type="invalid">Please input a permit issue date.</Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row>

                                                            <Row>
                                                                <Col md={6}>
                                                                    <Form.Group>
                                                                        <Form.Label><strong>Email</strong></Form.Label>
                                                                        <Form.Control
                                                                            required
                                                                            name="emailAddress"
                                                                            type="email"
                                                                            value={editedStudent.emailAddress}
                                                                            placeholder="Email address"
                                                                            onChange={this.handleEditChange}
                                                                            autoComplete="email"
                                                                        />
                                                                        <Form.Control.Feedback type="invalid">Please input an email address.</Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <Form.Group>
                                                                        <Form.Label><strong>Parent Email</strong></Form.Label>
                                                                        <Form.Control
                                                                            name="parentEmailAddress"
                                                                            type="email"
                                                                            value={editedStudent.parentEmailAddress || ""}
                                                                            placeholder="Parent email address"
                                                                            onChange={this.handleEditChange}
                                                                            autoComplete="email"
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row>

                                                            <Form.Group>
                                                                <Form.Label><strong>Phone Number</strong></Form.Label>
                                                                <Form.Control
                                                                    required
                                                                    name="phone"
                                                                    type="tel"
                                                                    value={editedStudent.phone}
                                                                    placeholder="Phone number"
                                                                    onChange={this.handleEditChange}
                                                                    autoComplete="tel-national"
                                                                />
                                                                <Form.Control.Feedback type="invalid">Please input a phone number.</Form.Control.Feedback>
                                                            </Form.Group>

                                                            <Form.Group>
                                                                <Form.Label><strong>Notes</strong></Form.Label>
                                                                <Form.Control
                                                                    name="note"
                                                                    type="text"
                                                                    value={editedStudent.note}
                                                                    placeholder="Optional notes"
                                                                    onChange={this.handleEditChange}
                                                                />
                                                            </Form.Group>

                                                            <Form.Check
                                                                disabled
                                                                inline
                                                                label="Completion Certificate Paid"
                                                                type="checkbox"
                                                                id="addCompletionCertificate"
                                                                checked={editedStudent.certPaymentStatus}
                                                                onChange={() => this.onCertificateChange(editedStudent.certPaymentStatus)}
                                                                style={{ marginBottom: "1rem" }}
                                                            />

                                                            <div style={{ display: "flex", gap: "0.5rem" }}>
                                                                <Button variant="primary" disabled={saving} type="submit">
                                                                    {saving ? <><Spinner animation="border" size="sm" /> Saving…</> : "Update"}
                                                                </Button>
                                                                <Button variant="outline-secondary" disabled={saving} onClick={this.handleCancelEdit}>
                                                                    Cancel
                                                                </Button>
                                                            </div>
                                                        </Form>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                )}
            </div>
        );
    }
}
